import { Box, Divider, Grid } from '@mui/material';
import CaseInfoItem from 'components/case/CaseInfoItem/CaseInfoItem';
import CPTItem from 'components/case/CPTItem/CPTItem';
import ICDItem from 'components/case/ICDItem/ICDItem';
import CustomText from 'components/common/CustomText/CustomText';
import LabelValueRow from 'components/common/LabelValueRow/LabelValueRow';
import React, { useEffect, useMemo, useState } from 'react'
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';
import { ICD } from 'types/types';
import { CPT } from 'types/types/Types';

interface Props {
  cpts: any[];
}

export default function RegistryCPTDetails({ cpts }: Props) {
  const globalStyles = useGlobalStyles();
  const [totalRVUs, setTotalRVUs] = useState<number>(0);
  const [totalReimbursable, setTotalReimbursable] = useState<number>(0);

  const calculateRVUs = () => {
    let maxRvu = 0;
    let sumOfRestOfRvus = 0;
    let sumRvu = cpts.reduce(function (sum: number, item: any) {
      return (sum = sum + (item.rvu_value * item.quantity));
    }, 0);
    setTotalRVUs(sumRvu);
    for (let i = 0; i < cpts.length; i++) {
      if (cpts[i].rvu_value > maxRvu) {
        maxRvu = cpts[i].rvu_value;
      }
    }
    maxRvu = Number(maxRvu);
    sumOfRestOfRvus = sumRvu - maxRvu;
    const sumOfTotalReimbursable = maxRvu + (sumOfRestOfRvus * 0.5);
    setTotalReimbursable(sumOfTotalReimbursable);
  }

  useEffect(() => {
    if (cpts?.length > 0) {
      calculateRVUs();
    }
  }, [cpts])

  return (
    <Box className={globalStyles.sectionContainer}>
      <Box className={globalStyles.sectionHeader}>
        <CustomText
          text="CPT Codes and RVUs"
          color={colors.primary}
          fontWeight={600}
        />
      </Box>

      <Divider />

      <Box px={3} mt={2}>
        <LabelValueRow
          label="Total RVUs"
          value={totalRVUs.toFixed(3)}
        />

        <LabelValueRow
          label="Total Reimbursable RVUs"
          value={totalReimbursable.toFixed(3)}
        />
      </Box>

      <Grid container p={3} spacing={1.5}>
        {cpts?.map((item: any, index: number) => (
          <Grid
            size={{ xs: 12, md: 6 }}
            key={`${item.code}-${index}`}>
            <CPTItem item={item} />
          </Grid>
        ))}

        {cpts?.length == 0 && (
          <Box>
            <CustomText text={'N/A'} />
          </Box>
        )}
      </Grid>

    </Box>
  )
}
